/* @ngInject */

export default (
  $rootScope,
  $scope,
  $q,
  $stateParams,
  organizationsService,
  accountsService,
  uiService,
  eventService,
  billingService,
  priceFinderService,
  authenticationService,
  webpage,
  ACCOUNT,
  ORGANIZATION
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    totalAccounts: 0,
    organizationSearch: '',
    availableOrganizationGroupsAndBranchesOriginal: [],
    availableOrganizationGroupsAndBranches: [],
    organizationGroupsAndBranchesList: null,
    isSearching: false,
    isReady: false
  };

  /*
   * Events
   * --------------------------------------------------------------------------------
   */
  $scope.$on('exportBillables', ($event) => {
    $event.preventDefault();
    uiService.toast({
      text: {
        p1: 'Billables',
        p2: 'are being exported',
        p3: 'please wait ...'
      },
      warn: true,
      progress: true
    });
    billingService.getBillables();
  });

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.searchOrganizations = () => {
    $scope.Model.isSearching = true;
    $scope.searchOrganizationsStart();
  };
  $scope.searchOrganizationsStart = _.debounce(() => {
    $scope.Model.availableOrganizationGroupsAndBranches = null;
    uiService.scopeApply(() => {
      if (String($scope.Model.organizationSearch).length > 0) {
        const res = _.filter(
          $scope.Model.availableOrganizationGroupsAndBranchesOriginal,
          (o) =>
            String(o?.organization?.name)
              .toLowerCase()
              .indexOf(String($scope.Model.organizationSearch).toLowerCase()) > -1
        );
        const grpIds = _.uniq(_.compact(_.map(res, 'idParent')));
        const grp = _.filter(
          $scope.Model.availableOrganizationGroupsAndBranchesOriginal,
          (o) => grpIds.indexOf(o.id) > -1
        );
        $scope.Model.availableOrganizationGroupsAndBranches = _.union(res, grp);
      } else {
        $scope.Model.availableOrganizationGroupsAndBranches =
          $scope.Model.availableOrganizationGroupsAndBranchesOriginal;
      }
      $scope.Model.isSearching = false;
    }, 100);
  }, 500);
  $scope.hasGroupsOrBranches = (organizationToDelete) => {
    if (!organizationToDelete.isRoot() && !organizationToDelete.isGroup()) {
      return undefined;
    }
    return _.find(
      $scope.Model.availableOrganizationGroupsAndBranches,
      (o) => (organizationToDelete.isRoot() ? o.idRoot : o.idParent) === organizationToDelete.id
    );
  };
  $scope.organizationGroupsAndBranchesDelete = ($event, organization) => {
    if (
      organization.isSubscribed() ||
      organization.isPartnerSubscribed() ||
      organization.isPhoneSubscribed()
    ) {
      uiService.toast({
        text: {
          p1: `${organization.getName()} organization`,
          p2: 'has active subscription(s)',
          p3: 'and cannot be deleted'
        },
        warn: true
      });
    } else if ($scope.hasGroupsOrBranches(organization) !== undefined) {
      uiService.toast({
        text: {
          p1: `${organization.getName()} organization`,
          p2: 'has sub organizations',
          p3: 'and cannot be deleted'
        },
        warn: true
      });
    } else {
      eventService.dialogDeleteConfirmation({
        event: $event,
        selectedData: organization,
        organizationName: organization.getName(),
        toast: 'Organization',
        docType: '__global_organization'
      });
    }
  };
  $scope.$on('groupsAndBranchesAdd', (e, $event) => {
    eventService.groupsAndBranchesAdd({ event: $event });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.getTotalOrganizations = () =>
    $scope.Model.availableOrganizationGroupsAndBranches.length + 1;
  $scope.getTotalGroups = () =>
    _.filter($scope.Model.availableOrganizationGroupsAndBranches, (org) => org.isGroup())
      .length;
  $scope.getTotalBranches = () =>
    _.filter($scope.Model.availableOrganizationGroupsAndBranches, (org) => org.isBranch())
      .length;

  $scope.organizationGroupsAndBranchesAdded = (organizationGaB) => {
    $scope.Model.organizationGroupsAndBranchesList.setDataAppend(organizationGaB);
  };
  $scope.organizationGroupsAndBranchesEdited = (organizationGaB) => {
    $scope.Model.organizationGroupsAndBranchesList.setDataReplace(organizationGaB);
  };
  $scope.listClick = (event, data) => {
    eventService.groupsAndBranchesEdit({ event: null, organization: data });
  };
  $scope.listMove = (event, data) => {
    if (authenticationService.isOwner()) {
      eventService.groupsAndBranchesMove({ event: null, organization: data });
    }
  };
  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };
  $scope.listReady = (list) => {
    $scope.Model.organizationGroupsAndBranchesList = list;
  };

  /*
   * Run Controller
   * --------------------------------------------------------------------------------
   */
  const init = () => {
    webpage.pageTitle('Loading, please wait');

    if ($rootScope.CurrentAccount.isAdministrator) {
      $q.all([
        organizationsService.getAvailableGoB({
          isActive: true,
          fields: ORGANIZATION.FIELDS.LIST
        }),
        accountsService.getAvailable({
          isActive: true,
          fields: ACCOUNT.FIELDS.LIST_COMPACT
        }),
        accountsService.getInInstance()
      ])
        .then((data) => {
          // Set Model values
          const availableOrganizationGroupsAndBranches = data[0];
          const availableAccounts = data[1];
          const totalAccounts = data[2];
          $scope.Model.availableOrganizationGroupsAndBranchesOriginal = angular.copy(
            availableOrganizationGroupsAndBranches
          );
          $scope.Model.availableOrganizationGroupsAndBranches = availableOrganizationGroupsAndBranches;
          $scope.Model.availableAccounts = availableAccounts;
          $scope.Model.totalAccounts = totalAccounts;

          // Declare Model as Ready and start rendering the page
          webpage.pageTitle('Groups and branches : Settings');
          $scope.Model.isReady = true;
        })
        .then(() => {
          if (
            $stateParams.code &&
            $stateParams.state &&
            $stateParams.state.includes('pricefinder')
          ) {
            const idAccount = $stateParams.state.split('pricefinder')[1];
            return priceFinderService.authenticated({
              code: $stateParams.code,
              state: $stateParams.state,
              idAccount
            });
          }
          return null;
        })
        .then((response) => {
          // Check if we performed 3rd Party Authentication
          if (response && response.provider) {
            uiService.toast({
              text: {
                p1: 'Authentication with',
                p2: response.provider,
                p3: response.status ? 'completed successfully' : 'has failed'
              },
              warn: !response.status
            });
          }
        });
    }
  };

  init();

  $scope.organizationGroupsAndBranchesDeleted = (organization) => {
    $scope.Model.organizationGroupsAndBranchesList.removeData(organization);
    init();
  };
  $scope.organizationGroupsAndBranchesMoved = () => {
    init();
  };
};
